
export interface CustomerDetailApi {
  id: string;
  name: string;
  accountNumber: string;
  currency: string;
  outstanding: number;
  overdue: number;
  creditLimit: number;
  dso: number | null;
  risk: "high" | "medium" | "low";
  lastPayment?: string;
  contact: string;
  phone: string;
  address: string;
  paymentTerms: string;
  collectionStrategyId?: string;
  creditControllerId?: string;
  accountManagerId?: string;
  onStop?: boolean;
  status?: string;
  userSortKey1?: string;
  userSortKey2?: string;
  userSortKey3?: string;
  userSortKey4?: string;
  userSortKey1Label?: string;
  userSortKey2Label?: string;
  userSortKey3Label?: string;
  userSortKey4Label?: string;
}

export interface CustomerFinancialApi {
  outstanding: number;
  overdue: number;
  creditLimit: number;
  availableCredit: number;
  paymentTerms: string;
  dso: number;
  risk: "high" | "medium" | "low";
  creditUtilizationPercent: number;
}

export interface CustomerAgingApi {
  current: number;
  days1_30: number;
  days31_60: number;
  days61_90: number;
  days90Plus: number;
  total: number;
  overdue: number;
}

export interface InvoiceApi {
  id: string;
  invoiceNumber: string;
  date: string;
  dueDate: string;
  amount: number;
  status: "overdue" | "outstanding" | "paid";
  daysOverdue: number;
}

export interface OutstandingInvoicesApiResponse {
  invoices: InvoiceApi[];
  totalOutstanding: number;
  totalOverdue: number;
}

export interface PaymentAllocationApi {
  invoiceId: string;
  invoiceNumber: string;
  invoiceDate: string;
  amount: number;
}

export interface PaymentApi {
  id: string;
  paymentNumber: string;
  date: string;
  amount: number;
  method: string;
  reference: string;
  allocations: PaymentAllocationApi[];
}

export interface PaymentHistoryApiResponse {
  payments: PaymentApi[];
  totalPayments: number;
  lastPaymentDate?: string;
}

export interface CommunicationApi {
  id: string;
  customerId: string;
  customerName: string;
  contactName: string;
  type: "email" | "phone" | "chat" | "meeting" | "sms" | "video" | "note" | "portal";
  subject: string;
  content: string;
  status: "sent" | "delivered" | "read" | "replied" | "completed" | "failed";
  direction: "inbound" | "outbound";
  createdAt: string;
  createdBy: string;
  metadata?: {
    emailTo?: string;
    emailFrom?: string;
    duration?: string;
    attendees?: string[];
  };
}

export interface CommunicationsApiResponse {
  communications: CommunicationApi[];
  totalCount: number;
}

export interface ContactApi {
  id: string;
  title?: string;
  firstName: string;
  surname: string;
  email: string;
  phone: string;
  jobTitle?: string;
  company: string;
  customerId: string;
  address: string;
  notes: string;
  createdAt: string;
  lastContact: string;
  isPrimary: boolean;
}

export interface ContactsApiResponse {
  contacts: ContactApi[];
  totalCount: number;
}

export interface StubResponse {
  message: string;
}

export function isStubResponse(response: unknown): response is StubResponse {
  return response && typeof response === "object" && "message" in response && !("data" in response) && !("invoices" in response) && !("payments" in response) && !("communications" in response) && !("contacts" in response);
}
